/**
 * Function that validates a password against a set of conditions, and return an array of errors (if any)
 * @param {string} password 
 * @returns {string[]}
 * 
 * @category Utils
 */
export const validatePassword = (password) => {
    const errors = [];
  
    // Minimum length
    if (password.length < 8) {
      errors.push('be at least 8 characters long');
    }
  
    // Maximum length
    if (password.length > 20) {
      errors.push('not exceed 20 characters');
    }
  
    // Uppercase letter
    if (!/[A-Z]/.test(password)) {
      errors.push('include at least one uppercase letter');
    }
  
    // Lowercase letter
    if (!/[a-z]/.test(password)) {
      errors.push('include at least one lowercase letter');
    }
  
    // Digit
    if (!/\d/.test(password)) {
      errors.push('include at least one digit');
    }
  
    // Special character
    if (!/[!@#$%^&*]/.test(password)) {
      errors.push('include at least one special character (e.g., !@#$%^&*)');
    }
  
    return errors;
  };